<template>
    <v-flex xs12 lg12>
        <v-card flat>
            <v-card-text>

                <v-snackbar top v-model="success" color="success">
                    <span> <v-icon>check_circle</v-icon> {{messages}} </span>
                </v-snackbar>

                <v-snackbar top v-model="error" color="error">
                    <span> <v-icon>info</v-icon> {{messages}} </span>
                </v-snackbar>

                <v-flex xl12>
                    <v-layout wrap>
                        <v-spacer></v-spacer>
                        <v-text-field @input="getDataFromApi" append-icon="search" label="Procurar" single-line hide-details v-model="search"></v-text-field>
                    </v-layout>
                </v-flex>

                <v-data-table flat
                              :headers="headers"
                              :items="registries"
                              :rows-per-page-text="'Registros por página '"
                              :no-data-text="'Sem registros'"
                              :pagination.sync="pagination"
                              :total-items="totalRegistries"
                              :loading="loading"
                              class="elevation-0">
                    <template v-slot:items="props" backgroud="green">
                        <td class="text-xs-left">
                            <div v-if="props.item.status === 'S'"><b style="color:orange"> NÃO AVALIADO </b></div>
                            <div v-if="props.item.status === 'R'"><b style="color:red"> REPROVADO </b></div>
                            <div v-if="props.item.status === 'A'"><b style="color:green">  PUBLICADO </b></div>
                        </td>
                        <td class="text-xs-left">{{ props.item.full_name }}</td>
                        <td class="text-xs-left">{{ props.item.email }}</td>
                        <td class="text-xs-center">{{ props.item.phone }}</td>
                        <td class="text-xs-center">{{ props.item.comment }}</td>
                        <td class="text-xs-center">{{ props.item.created }}</td>
                        <td class="justify-center layout px-0">
                            <v-tooltip left>
                                <v-btn icon slot="activator" @click="doEdit(props.item)">
                                    <v-icon>edit</v-icon>
                                </v-btn>
                                <span>Responder</span>
                            </v-tooltip>
                            <v-tooltip v-if="props.item.status !='A'" left>
                                <v-btn icon slot="activator" flat color="success"
                                       @click.stop="doChange(props.item.id,'A')">
                                    <v-icon>thumb_up_alt</v-icon>
                                </v-btn>
                                <span>APROVAR</span>
                            </v-tooltip>
                            <v-tooltip left v-if="props.item.status !='R'" >
                                <v-btn icon slot="activator" flat color="error"
                                       @click.stop="doChange(props.item.id,'R')">
                                    <v-icon>thumb_down_alt</v-icon>
                                </v-btn>
                                <span>REPROVAR</span>
                            </v-tooltip>
                        </td>
                    </template>
                </v-data-table>
            </v-card-text>
            <v-dialog v-model="dialog" persistent max-width="50%">
                <v-card dark>
                    <v-card-title class="headline">
                        <span style="font-size: 14px;">Tem certeza que deseja {{action.action_name}} este registro?</span>
                    </v-card-title>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn dark color="red darken-1" flat @click.native="dialog = false">NÃO</v-btn>
                        <v-btn dark color="green darken-1" flat @click.native="change">SIM</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-card>
    </v-flex>
</template>
<script>
    export default {
        name: 'surveys-list',
        data() {
            return {
                success: false,
                error: false,
                dialog: false,
                messages: '',
                search: '',
                action: {
                    action_name: '',
                    id: 0,
                    status: ''
                },
                totalRegistries: 0,
                registries: [],
                loading: true,
                pagination: {rowsPerPage: 30, search: ''},
                headers: [
                    {text: 'Status', value: 'status', align: 'center'},
                    {text: 'Nome', value: 'full_name', align: 'left'},
                    {text: 'E-mail', value: 'email', align: 'left'},
                    {text: 'Telefone', value: 'mobile', align: 'center'},
                    {text: 'Comentário', value: 'coment', align: 'left'},
                    {text: 'Cadastro', value: 'created', align: 'center'},
                    {text: 'Ações', value: '', align: 'center'}
                ]
            }
        },
        watch: {
            pagination: {
                handler() {
                    this.getDataFromApi()
                },
                deep: true
            }
        },
        mounted() {
            this.getDataFromApi()
            this.$store.commit('setLoading', true)
        },
        methods: {
            doChange(row, status) {
                if (status == 'S') {
                    this.action.action_name = 'Suspender'
                } else if (status === 'A') {
                    this.action.action_name = 'Aprovar'
                } else if (status === 'D') {
                    this.action.action_name = 'Reprovar'
                }
                this.action.id = row
                this.action.status = status
                this.dialog = true
            },
            change() {
                var self = this
                self.loading = true
                self.axios.post('/update-surveys.json', this.action, {
                    headers: {
                        'Authorization': self.$store.state.token
                    }
                }).then((response) => {
                    if (response.data.success === true) {
                        self.getDataFromApi()
                        self.dialog = self.loading = false
                    }
                })
            },
            doEdit(row) {
                localStorage.setItem('register', JSON.stringify(row))
                this.$router.push('/reply')
            },
            getDataFromApi() {
                var self = this
                var data = this.pagination
                data.search = this.search
                data.role = this.role
                self.loading = true
                self.axios.get('/list-surveys.json', {
                    params: {
                        data
                    },
                    headers: {
                        'Authorization': self.$store.state.token
                    }
                }).then((response) => {
                    self.$store.commit('setLoading', false)
                    self.registries = response.data.registries
                    self.totalRegistries = response.data.totalRegistries
                    self.loading = false
                })
            }
        }
    }
</script>
